export default __webpack_public_path__ + "bf9ab08.png";